import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import _ from 'lodash';
const COLORS = [
    '#1976D2',
    '#FF0000',
    '#27B4D1',
    '#6F2EA3',
    '#DC7C08',
];
let UserInfoFormatterServiceImpl = class UserInfoFormatterServiceImpl {
    getDisplayName(userInfo) {
        if (!_.isEmpty(userInfo)) {
            return userInfo.nickname || userInfo.email || this._formatMobileNumber(userInfo.mobileNumber);
        }
        return '';
    }
    getAvatarColor(letter) {
        const code = (letter || '').toUpperCase().charCodeAt();
        if (code >= 48 && code <= 57) {
            return COLORS[(code - 48) % COLORS.length];
        }
        if (code >= 65 && code <= 90) {
            return COLORS[(code - 65) % COLORS.length];
        }
        return COLORS[0];
    }
    _formatMobileNumber(mobile_number) {
        if (!mobile_number) {
            return '';
        }
        const tel = mobile_number.split('');
        return _.fill(tel, '*', 3, tel.length - 4).join('');
    }
};
UserInfoFormatterServiceImpl = __decorate([
    injectable()
], UserInfoFormatterServiceImpl);
export { UserInfoFormatterServiceImpl };
